import TwoColumnLayout from "layout/TwoColumnLayout";
import React from "react";
import SystemMessagesPanel from "dashboard/SystemMessage/app";
import { AdvancingListDashboard } from "dashboard/AdvancingApprove/app";
import AdvancingProvidePanel from "dashboard/AdvancingProvide/app";
import ContactBirthdaysPanel from "dashboard/ContactBirthdays/app";
import LastModifiedShowsPanel from "dashboard/LastModified/app";
import ESignAgencyPanel from "dashboard/eSignAgencyDashboard/app";
import { isPanelVisible } from "utilities/panelUtils";
import BookingRequestsPanel from "dashboard/BookingRequests/app";
import ExternalShowsPanel from "dashboard/ExternalShows/app";
import UserTasksPanel from "dashboard/UserTasks/app";
import MyDetailsPanel from "personalsettings/mydetailspanel/MyDetailsPanel";
import WebDeveloperPanel from "./WebDeveloperPanel/app";
import { useLoaderData } from "react-router";

const Dashboard = () => {
  const viewModel = useLoaderData<server.viewmodel.DashboardFrontModel>();

  return <TwoColumnLayout>
    <TwoColumnLayout.LeftColumn
      gap="bigger"
    >
      {isPanelVisible(viewModel.systemMessagePanelConfig) &&
        <SystemMessagesPanel config={viewModel.systemMessagePanelConfig} />}

      {isPanelVisible(viewModel.eSignForAgencyPanelConfig) &&
        <ESignAgencyPanel config={viewModel.eSignForAgencyPanelConfig} />}

      {isPanelVisible(viewModel.advancingProvidePanelConfig) &&
        <AdvancingProvidePanel config={viewModel.advancingProvidePanelConfig} />}

      {isPanelVisible(viewModel.advancingApprovePanelConfig) &&
        <AdvancingListDashboard config={viewModel.advancingApprovePanelConfig} />}

      {isPanelVisible(viewModel.lastModifiedPanelConfig) &&
        <LastModifiedShowsPanel config={viewModel.lastModifiedPanelConfig} />}

      {isPanelVisible(viewModel.bookingRequestPanelConfig) &&
        <BookingRequestsPanel config={viewModel.bookingRequestPanelConfig} />}

      {isPanelVisible(viewModel.externalInputPanelConfig) &&
        <ExternalShowsPanel config={viewModel.externalInputPanelConfig} />}

      {isPanelVisible(viewModel.webDeveloperPanelConfig) &&
        <WebDeveloperPanel config={viewModel.webDeveloperPanelConfig} />}

    </TwoColumnLayout.LeftColumn>

    <TwoColumnLayout.RightColumn
      gap="bigger">
      {isPanelVisible(viewModel.userDetailPanelConfig) &&
        <MyDetailsPanel menuItems={[]} config={viewModel.userDetailPanelConfig} />}

      {isPanelVisible(viewModel.tasksPerUserPanelConfig) &&
        <UserTasksPanel config={viewModel.tasksPerUserPanelConfig} />}

      {isPanelVisible(viewModel.contactBirthdayPanelConfig) &&
        <ContactBirthdaysPanel config={viewModel.contactBirthdayPanelConfig} />}
    </TwoColumnLayout.RightColumn>
  </TwoColumnLayout>;
};

export default Dashboard;